import { MenuItem, Select } from "@mui/material";
import type { WaterReadType } from "../../models/WaterBilling";
import { WATER_READ_TYPE } from "../../models/WaterBilling";

export const ReadTypeCell = ({
	value,
	onChange,
}: {
	value: WaterReadType | null;
	onChange: (value: WaterReadType | null) => void;
}) => (
	<Select
		value={value ?? ""}
		variant="standard"
		disableUnderline
		displayEmpty
		fullWidth
		onChange={(event) =>
			onChange(
				event.target.value === ""
					? null
					: (event.target.value as WaterReadType),
			)
		}
		sx={{
			fontSize: 11,
			"& .MuiSelect-select": {
				py: 0,
				pr: "18px !important",
				textAlign: "center",
			},
			"& .MuiSelect-icon": { fontSize: 16, right: 0 },
		}}
	>
		<MenuItem value="">—</MenuItem>
		<MenuItem value={WATER_READ_TYPE.ACTUAL}>Actual</MenuItem>
		<MenuItem value={WATER_READ_TYPE.ESTIMATE}>Estimate</MenuItem>
	</Select>
);
